var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlob2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#334155",
    d: "M52.3,-15.6C60,6.7,53.1,35.1,35.7,47.2C18.4,59.4,-9.3,55.2,-30.6,40.2C-51.9,25.2,-66.7,-0.7,-60.5,-20.8C-54.4,-41,-27.2,-55.5,-2.4,-54.8C22.3,-54,44.6,-37.9,52.3,-15.6Z",
    transform: "translate(100 100)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob2);
export default __webpack_public_path__ + "static/media/blob-2.2dc36c9e82a4934577e7240a8f213a6c.svg";
export { ForwardRef as ReactComponent };